import styled from "styled-components";
import Circular from "@sprout/client-components/dist/ProgressBar/Circular";
const TopicPageLoader = styled(Circular)`
  margin: 48px auto;
`;
export default TopicPageLoader;
